"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    landscape: Boolean,
    noDisplay: Boolean,
    displayColor: String
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/muse-ui/lib/Picker/mixins/props.js
// module id = Gmvi
// module chunks = 0